import axios from 'axios';

const api = axios;

export interface ChatMessage {
  id?: number | string;
  session_id?: string;
  role: 'user' | 'assistant';
  content: string;
  created_at?: string;
}

export interface ChatSession {
  id: string;
  user_id?: number;
  title: string;
  created_at: string;
  updated_at: string;
  messages?: ChatMessage[];
}

export interface ChatResponse {
  response: string;
  session_id: string;
  intent?: string;
  data?: any;
}

export interface SuggestedPrompt {
  text: string;
  category?: string;
}

export const chatService = {
  sendMessage: async (message: string, sessionId?: string): Promise<ChatResponse> => {
    const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    const requestBody = { 
      message, 
      session_id: sessionId || null,
      current_date: currentDate 
    };
    console.log('[Chat] Sending request:', requestBody);
    const response = await api.post('/chat', requestBody);
    console.log('[Chat] Received response:', { session_id: response.data.session_id });
    return response.data;
  },

  getSuggestions: async (): Promise<SuggestedPrompt[]> => {
    const response = await api.get('/chat/suggestions');
    return response.data.suggestions || response.data;
  },

  getHistory: async (): Promise<ChatSession[]> => {
    const response = await api.get('/chat/history');
    return response.data.sessions || response.data;
  },

  createSession: async (title?: string): Promise<ChatSession> => {
    const response = await api.post('/chat/sessions', { title });
    return response.data.session || response.data;
  },

  getSession: async (sessionId: string): Promise<ChatSession> => {
    const response = await api.get(`/chat/sessions/${sessionId}`);
    return response.data.session || response.data;
  },

  deleteSession: async (sessionId: string): Promise<void> => {
    await api.delete(`/chat/sessions/${sessionId}`);
  },
};

export default chatService;
